import React, { useEffect, useState } from "react";
import { fields } from "../Utils/data";
import women from "../../Images/contactus/women-2.png";
import Validation from "./Validation";
import axios from "axios";

const Form = () => {
  const [errors, setErrors] = useState({});
  // console.log(errors)
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    fName: "",
    lName: "",
    mobile: "",
    email: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const PostData = async (data) => {
    try {
      const response = await axios.post(
        "https://newdirections.org.in/contactForm.php",
        {
          fName: data.fName,
          lName: data.lName,
          email: data.email,
          mobile: data.mobile,
          message: data.message,
        }
      );
      console.log(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = Validation(formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      await PostData(formData);
      console.log("Form data submitted:", formData);

      setIsSubmitted(true);
      setFormData({
        fName: "",
        lName: "",
        email: "",
        mobile: "",
        message: "",
      });
    }
  };
  return (
    <div className="bg-ndlogoBlue p-3 mt-2 md:p-10 md:mt-5">
      <div className="flex flex-col gap-3  md:gap-5 justify-center my-3  md:my-7 mx-auto md:w-[70%]">
        <h1 className="text-2xl md:text-4xl text-Orange font-bold text-center">
          Get in Touch With Us
        </h1>
        <p className=" hidden md:flex text-center text-lightGray">
          You can contact us any way that is convenient for you. We are
          available 24/7 via fax or email. You can also use a quick contact form
          below or visit us personally. We would be happy to answer your
          questions.
        </p>
        <p className="flex  md:hidden text-center text-lightGray">
          You can contact us any way that is convenient for you. We are
          available 24/7 via fax or email.
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="  w-full flex  flex-col-reverse lg:flex-row gap-2 md:gap-6 bg-white bg-opacity-90 p-3 md:p-8 rounded-2xl shadow-lg backdrop-blur-sm items-center justify-center"
      >
        <div className="w-full  lg:w-[60%] ">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
            {fields.map((item, i) => {
              return (
                <div key={i} className="grid gap-2">
                  <label
                    className="text-darkGray text-base font-medium"
                    htmlFor={item.name}
                  >
                    {item.label}
                  </label>
                  <input
                    id={item.name}
                    name={item.name}
                    value={formData[item.name]}
                    type={item.type || "text"}
                    placeholder={
                      item.placeholder ||
                      `Enter your ${item.label.toLowerCase()}`
                    }
                    className={`p-3 rounded-full  focus:outline-none focus:ring-2 focus:ring-Orange focus:border-Orange ${
                      errors[item.name]
                        ? "border border-error"
                        : "border border-neutral"
                    }`}
                    onChange={handleChange}
                  />
                  {errors[item.name] && (
                    <p className="text-error text-sm mt-1">
                      {errors[item.name]}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <div className="grid gap-3">
            <label
              className="text-darkGray text-base font-medium"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              onChange={handleChange}
              value={formData.message}
              placeholder="Start typing here..."
              rows="4"
              className={`rounded-2xl p-4  resize-none focus:outline-none focus:ring-2 focus:ring-Orange focus:border-Orange  
                ${
                  errors.message
                    ? "border border-error"
                    : "border border-neutral"
                }`}
            ></textarea>
            {errors.message && (
              <p className="text-red-500 text-sm">{errors.message}</p>
            )}
          </div>
          {isSubmitted ? (
            <p className="text-green">Your form is submitted successfully</p>
          ) : (
            ""
          )}

          <div className="grid my-4 md:my-10 place-items-center">
            <button
              type="submit"
              className="bg-Orange hover:bg-white  cursor-pointer hover:text-Orange hover:border hover:border-Orange transition-colors duration-300 text-white text-lg font-semibold py-2 px-10 rounded-full"
            >
              Submit
            </button>
          </div>
        </div>

        <div className="w-full lg:w-[40%] ">
          <img src={women} className=" object-fit-cover  rounded" />
        </div>
      </form>
    </div>
  );
};

export default Form;
